import {
    formatterDateToUTC
} from "@/util/util";

export const refundFormOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    submitBtn: false,
    emptyBtn: false,
    addBtn: false,
    menu: false,
    columnBtn: false,
    refreshBtn: false,
    searchBtn: false,
    header: false,
    width: "50%",
    border: true,
    // cellBtn:false,
    //viewBtn: true,
    menuWidth: '300',
    labelWidth: '150',
    column: [
        //dispaly 不起作用,只能判断订单状态,打开不同的option配置
        {
            label: "商品名称",
            type: "input",
            span: 13,
            prop: "name"
        },
        {
            label: "商品单位",
            span: 13,
            type: "input",
            prop: "unit"
        },
        {
            label: "采购价格",
            span: 13,
            type: "input",
            prop: "price"
        },
        {
            label: "品牌名称",
            span: 13,
            type: "input",
            prop: "brandName"
        },
        {
            label: "一级分类",
            span: 13,
            type: "input",
            prop: "firstClassifyName"
        },
        {
            label: "二级分类",
            span: 13,
            type: "input",
            prop: "secondClassifyName"
        },
        {
            label: "商品属性",
            span: 13,
            prop: "maps",
            width: '340px',
            formatter: function (row, value, label, column) {
                //    return formatterDateToUTC(value)
                // console.log('row:',row)
                // console.log('value:', value)
                // console.log('lable:', label)
                // console.log('column:', column)
                // let list = ''
                // value.map(item => {
                //     list += item.skuKey + ':' + item.skuValue + '  '
                //     //    return list
                // })
                // console.log(list)
                // return value[0].skuKey+':'+value[0].skuValue
                return row.skuValue
            },
        },
        {
            label: "采购数量",
            span: 13,
            type: "input",
            prop: "amount"
        },
        {
            label: "商铺地址",
            prop: "address",
            span: 13,
            type: "input",
            hide: true,
            // visdiplay:false,
            // visdiplay:false,
            // viewVisdiplay:false,
            // editVisdiplay:false,
            // addVisdiplay:false,
            // readonly:true,
            // clearable:false,
            // click: ({ value, column }) => {
            //     console.log(value, column)
            // },
            // change: ({ value, column }) => {
            //         this.obj.address = value;
            //         this.$message.success('address change')
            //     },

        },
        {
            label: "日期",
            prop: "date",
            type: "date",
            hide: true,
            span: 13,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            mock: {
                type: 'datetime',
                format: 'yyyy-MM-dd'
            },
        },
        {
            label: "日期时间",
            prop: "datetime",
            type: "datetime",
            span: 13,
            hide: true,
            row: true,
            format: 'yyyy-MM-dd hh:mm:ss',
            valueFormat: 'yyyy-MM-dd hh:mm:ss',
            mock: {
                type: 'datetime',
                format: 'yyyy-MM-dd hh:mm:ss',
                now: true,
            },
        },
        {
            label: "时间",
            prop: "time",
            type: "time",
            hide: true,
            span: 8,
            format: 'hh:mm:ss',
            valueFormat: 'hh:mm:ss',
            mock: {
                type: 'datetime',
                format: 'hh:mm:ss'
            },
        }
    ]
};